<template>
  <!-- <h1>开发专用页面</h1> -->
  <printSysContent
      :printType="printType"
      :modelObj="modelObj"
      :member="'pagetmsWaybill'"
      :modelClassName="modelClassName"
      :selectTableData="selectTableData"
      :dataSource="dataSource"
  ></printSysContent>
</template>
<script>
import printSysContent from "@/components/printSys/content.vue";
import utils from "@/assets/js/tool.js";

export default {
  name: 'printSetting',
  components: {
    printSysContent
  },
  data() {
    return {
      // 创建新的打印
      printTitle: "创建模板",
      printType: 1,
      modelObj: null,
      modelClassName: null,
      selectTableData: [],
      printVisible: false,
      dataSource: null
    }
  },
  created() {
    let printClassName = this.$route.query.className;
    console.log('printClassName',printClassName);
    if (printClassName) {
      // 根据存储的modelClassName重建dataSource函数
      this.dataSource = this.createDataSource(printClassName);
    }
  },
  methods: {
    // 创建对应的dataSource函数
    createDataSource(selectNumber) {
      return (rows, className) => {
        // 返回一个函数，该函数具有与原始dataSource相同的签名
        return new Promise((resolve, reject) => {
          // 根据不同的modelClassName调用不同的API
          // 这里需要根据实际业务逻辑来实现
          let conditonKey = this.$route.query.conditonKey;
          let condictions = []
          condictions.push({
            conditonKey: conditonKey,
            conditonVal: this.$route.query.id
          })
          const params = {}
          params.conditionReqs = condictions
          params.number = selectNumber
          this.$API
              .runReport(params)
              .then((res) => {
                const result = res.data.result.datas;
                resolve(result);
              })
              .catch((err) => {
                reject(err);
              });
        });
      }
    },
    onPrintConfirm() {
      this.printVisible = false;
    },
    onPrintCancel() {
      this.printVisible = false;
    },
    onPrint() {
      this.printVisible = true;
    }
  }
}
</script>
